import { Flex, Spin, Typography } from "antd";
import {
  StyledBigXLText,
  StyledBorderedRowBox,
  StyledDivider,
  StyledMonthIncome,
  StyleMonthRevenuesWrapper,
  StyleMonthsRevenuesWrapper,
  StyleSixMonthsRevenuesWrapper,
} from "./style";
import { IncomeHistoryModal } from "./IncomeHistory";
import { StyledFilterButton } from "../../components/common";
import { useAppDispatch, useAppSelector } from "../../store/config";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { formatNumber, getCurrencySymbol } from "../../utils/utils";
import {
  getRevenuesStart,
  resetDashboardSixMonthsRevenues,
} from "../../store/features/dashboard/revenues/revenues-slice";
import { useTranslation } from "react-i18next";

export const Revenues = (props: {
  setIncomeHistoryModalOpen: (open: boolean) => void;
  incomeHistoryModalOpen: boolean;
  totalRevenue: number;
}) => {
  const { incomeHistoryModalOpen, setIncomeHistoryModalOpen, totalRevenue } =
    props;
  const { t } = useTranslation();

  const getMonth = (date: string) => {
    const parsedDate = new Date(date);
    const month = t(monthsInEnglish[parsedDate.getMonth()]);

    return `${month}`;
  };
  const dispatch = useAppDispatch();
  const { id: trainerId } = useParams<{ id: string }>();

  const { sixMonthsRevenues, loading } = useAppSelector(
    (state) => state.dashboardRevenues
  );

  useEffect(() => {
    dispatch(
      getRevenuesStart({
        trainerId,
        pagination: { page: 0, limit: 6, skip: 0 },
        isSixMonths: true,
      })
    );
    return () => {
      dispatch(resetDashboardSixMonthsRevenues());
    };
  }, []);

  return (
    <Spin spinning={loading && !incomeHistoryModalOpen}>
      <StyledBorderedRowBox justify="space-between" style={{ height: "176px" }}>
        <Flex
          vertical
          justify="space-between"
          style={{ minWidth: "max-content" }}
        >
          <Typography.Title level={5}>{t("Total Revenues")}</Typography.Title>
          <Flex vertical gap={0}>
            <Typography.Text>{t("Total Revenues Up To Today")}</Typography.Text>
            <StyledBigXLText>
              {sixMonthsRevenues[0]?.currency &&
                getCurrencySymbol(sixMonthsRevenues[0].currency)}
              {formatNumber(totalRevenue)}
            </StyledBigXLText>
          </Flex>
        </Flex>

        <StyleMonthsRevenuesWrapper>
          <StyledFilterButton onClick={() => setIncomeHistoryModalOpen(true)}>
            {t("All")}
          </StyledFilterButton>

          <StyleSixMonthsRevenuesWrapper>
            {sixMonthsRevenues.map((item, index) => (
              <StyleMonthRevenuesWrapper key={index}>
                <StyledDivider />
                <StyledMonthIncome>
                  <Typography.Text>{getMonth(item.createdAt)}</Typography.Text>
                  <Typography.Title level={5} style={{ margin: 0 }}>
                    {getCurrencySymbol(item.currency)}
                    {formatNumber(item.revenue)}
                  </Typography.Title>
                </StyledMonthIncome>
                {index === sixMonthsRevenues.length - 1 && <StyledDivider />}
              </StyleMonthRevenuesWrapper>
            ))}
          </StyleSixMonthsRevenuesWrapper>
        </StyleMonthsRevenuesWrapper>
        <IncomeHistoryModal
          open={incomeHistoryModalOpen}
          setOpen={setIncomeHistoryModalOpen}
        />
      </StyledBorderedRowBox>
    </Spin>
  );
};

export const monthsInEnglish = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
